import React from "react";

type PrivacyChoicesLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "children" | "href"
>;

/** Reopens consent controls when available, with the cookie policy as fallback. */
export default function PrivacyChoicesLink({
  style,
  ...props
}: PrivacyChoicesLinkProps) {
  return (
    <a
      {...props}
      href="/terms-and-privacy#cookies"
      data-openings-privacy-choices-trigger
      referrerPolicy="no-referrer"
      style={{
        color: "inherit",
        fontSize: 13,
        textUnderlineOffset: 3,
        ...style,
      }}
    >
      Privacy &amp; cookies
    </a>
  );
}
